module.exports = __webpack_public_path__ + "img/scratch-main-image.96ba88a2.png";